import Component from '@glimmer/component';

import linkToState from 'ember-route-state/helpers/link-to-state.js';
import isStateActive from 'ember-route-state/helpers/is-state-active.js';

import CButton from 'rise-ui/components/c-button.gjs';
import CIcon from 'rise-ui/components/c-icon.gjs';
import Sticky from 'rise-ui/components/sticky.gjs';
import NextStep from 'rise-ui/components/time-series/next-step.gjs';
import string from 'rise-ui/helpers/string.js';

export default class StepsStickySmallComponent extends Component {
  <template>
    {{#if (isStateActive "time-series.search")}}
      <Sticky @name="wizard-step--small" @type="small-wizard">
        <:content>
          {{string "time-series-search-route"}}
        </:content>
        <:right>
          <NextStep
            @linkTo={{linkToState "time-series.selection"}}
            @title="Continue to {{string "time-series-selection-route"}}"
          />
        </:right>
      </Sticky>
    {{else if (isStateActive "time-series.selection")}}
      <Sticky @name="wizard-step--small" @type="small-wizard">
        <:left>
          <CButton
            @type="primary"
            @linkTo={{linkToState "time-series.search"}}
            @title="Back to {{string "time-series-search-route"}}"
          >
            <CIcon @icon="previous-step" @text="Previous Step" />
            <span class="c-sticky__action c-sticky__action--min">
              Previous
            </span>
            <span class="c-sticky__action c-sticky__action--max">
              Previous Step
            </span>
          </CButton>
        </:left>
        <:content>
          {{string "time-series-selection-route"}}
        </:content>
        <:right>
          <NextStep
            @linkTo={{linkToState "time-series.output"}}
            @title="Continue to {{string "time-series-output-route"}}"
          >
            <span class="c-sticky__action c-sticky__action--min">
              Next
            </span>
            <span class="c-sticky__action c-sticky__action--max">
              Next Step
            </span>
          </NextStep>
        </:right>
      </Sticky>
    {{else if (isStateActive "time-series.output")}}
      <Sticky @name="wizard-step--small" @type="small-wizard">
        <:left>
          <CButton
            @type="primary"
            @linkTo={{linkToState "time-series.selection"}}
            @title="Back to {{string "time-series-selection-route"}}"
          >
            <CIcon @icon="previous-step" @text="Previous Step" />
            <span class="c-sticky__action c-sticky__action--min">
              Previous
            </span>
            <span class="c-sticky__action c-sticky__action--max">
              Previous Step
            </span>
          </CButton>
        </:left>
        <:content>
          {{string "time-series-output-route"}}
        </:content>
      </Sticky>
    {{/if}}
  </template>
}
